// https://jonsuh.com/hamburgers/
// https://github.com/jonsuh/hamburgers/blob/master/dist/hamburgers.css

import { useState } from 'react'
import { Link } from 'gatsby'

/** @jsx jsx */
import { jsx } from 'theme-ui'

import { MdNewReleases } from "react-icons/md"

const Menu = (props) => {
    const [active, setActive] = useState(false)

    const {
        zones
    } = props

    return (
        <nav 
            className={active ? 'is-active' : null} 
            sx={{
                position: 'relative',
            }}
        >
            <button 
                type="button"
                aria-label="Menu" aria-controls="navigation" aria-expanded={active}
                sx={{
                    p: 2, m: 0,
                    border: 'none',
                    display: 'inline-block',
                    cursor: 'pointer',
                    transitionProperty: 'opacity, filter', transitionDuration: '0.15s', transitionTimingFunction: 'linear',
                    overflow: 'visible',
                    backgroundColor: 'transparent',
                    ':hover': {
                        opacity: '0.7',
                    },
                    ':focus': {
                        outline: 'none',
                    }
                }}
                onClick={() => setActive( prevState => !prevState )} 
            >
                <span
                    sx={{
                        width: '40px',
                        height: '24px',
                        display: 'inline-block',
                        position: 'relative',
                        mb: '-15px',
                    }}
                >
                    <span className="hamburger-inner" sx={{
                        display: 'block', position: 'absolute', top: '50%',
                        marginTop: '-2px', width: '40px', height: '4px',
                        bg: 'primary',
                        borderRadius: 0,
                        transitionProperty: 'transform', transitionDuration: '0.15s', transitionTimingFunction: 'ease',
                        '.is-active &': {
                            transform: 'translate3d(0, -10px, 0) rotate(-45deg)',
                            transitionDelay: '0.22s',
                            transitionTimingFunction: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                        },
                        '::before': {
                            position: 'absolute',
                            width: '40px', height: '4px',
                            bg: 'primary',
                            borderRadius: 0,
                            content: '""',
                            display: 'block', 
                            top: '-10px',
                            transitionProperty: 'transform', transitionDuration: '0.15s', transitionTimingFunction: 'ease',
                            transition: 'top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19)',
                            '.is-active &': {
                                top: '0',
                                transform: 'rotate(-90deg)',
                                transition: 'top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1)', 
                            }
                        },
                        '::after': {    
                            position: 'absolute',
                            width: '40px', height: '4px', 
                            bg: 'primary',
                            borderRadius: 0,                       
                            content: '""',
                            display: 'block', 
                            bottom: '-10px', top: '-20px',
                            transitionProperty: 'transform', transitionDuration: '0.15s', transitionTimingFunction: 'ease',
                            transition: 'top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear',
                            '.is-active &': {
                                top: '0',
                                opacity: '0',
                                transition: 'top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s 0.22s linear',
                            }
                        } 
                    }}></span>
                </span>
            </button>

            <ul sx={{
                position: 'absolute', zIndex: '200',
                top: '50px', right: '0',
                bg: 'background',
                borderRadius: 1, 
                p: 2, m: 0,
                boxShadow: 0,
                textAlign: 'right',
                visibility: 'hidden',
                listStyleType: 'none',
                minWidth: '220px',
                opacity: '0',
                transitionProperty: 'opacity, visibility', transitionDuration: '0.5s', transitionTimingFunction: 'ease',
                '.is-active &': {
                    visibility: 'visible',
                    opacity: '1',
                    transitionDelay: '0.4s',
                },
                'li': {
                    display: 'block',
                    p: 2,
                }
            }}>
                {zones.map( zone => (
                    <li key={zone.id}>
                        <Link to={`/suisse-${zone.id}`} sx={{
                            color: 'text',
                            textDecoration: 'none',
                        }}>{zone.name}</Link>
                    </li>
                ))}

                <li sx={{
                    // borderTop: theme => `1px solid ${theme.colors.muted}`,
                    bg: 'primary', borderRadius: 0,
                    mt: 3,
                    // mb: '-4px',
                    a: {
                        color: 'background',
                        textDecoration: 'none',
                    }
                }}>
                    <Link to='/referencement' className="button" data-button="menu-cta">
                        <MdNewReleases sx={{mb: '-2px'}}/> Soyez référencé
                    </Link>
                </li>
            </ul>
        </nav>
    )
}

export default Menu